// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup__popup__4nJpE","closeButtonWrapper":"Popup__closeButtonWrapper__skQj9","titleWrapper":"Popup__titleWrapper__D6O42","content":"Popup__content__2sz4k"};